import React, { useContext } from 'react';
import { useTranslator } from '@jutro/locale';
import { useModal } from '@jutro/components';
import { FormModalPopover } from 'ml-components-platform-react';
import { MLProgressModalContext } from 'ml-portals-util-react';

function MLModalService() {
    const modalApi = useModal();
    const translator = useTranslator();
    const { updateProgressModalState } = useContext(MLProgressModalContext);

    const showErrorModal = (title, message, actionBtnLabel, additionalCssClass) => {
        return modalApi.showModal(
            <FormModalPopover
                title={title}
                showHeader={!!title}
                simpleMessage={message ? translator(message) : " "}
                actionBtnLabel={actionBtnLabel || undefined}
                additionalPEStyle={additionalCssClass}
            />
        );
    };
    const showInfo = (title, message, actionLabel) => {
        return modalApi.showModal(
            <FormModalPopover
                title={title}
                simpleMessage={message ? translator(message) : " "}
                actionBtnLabel={actionLabel || "Ok"}
            />
        );
    };

    /**
     * Use this function to show a modal to inform the user that some transaction is going on and he should wait.
     * @param {(string|Object)} title Optional, String or object (to be translated). 
     * @param {Promise} hidePromise Optional, this will close the dialog once the promise its completed. If null, the dialog will have to be closed manually using @see {@link hideProgressDialog} 
     * @param {boolean} shouldModalStayAsIs Optional, used to reset the window scroll to the top if true. Only relevant if the dialog is closed by the promise.
     * @param {number} initDelay Optional, delay on opening the progress modal, 1 second delay by default.
     */
    const showProgressDialog = (title, hidePromise, shouldModalStayAsIs, initDelay = 1000)=> {
        updateProgressModalState({
            type: 'ACTIVATE',
            title,
            initDelay,
            isCountRequired:hidePromise != null
        });

        if(hidePromise){
            hidePromise.then((response) => {
                if (!shouldModalStayAsIs) {
                    window.scrollTo(0, 0);
                }

                updateProgressModalState({
                    type: 'DEACTIVATE'
                });

                return response;
            }).catch((error) => {
                if (!shouldModalStayAsIs) {
                    window.scrollTo(0, 0);
                }

                updateProgressModalState({
                    type: 'DEACTIVATE'
                });

                return error;
            })
        }
    };

    /**
     * Use this function to show a modal to inform the user that some transaction is going on and he should wait.
     * @param {(string|Object)} title Optional, String or object (to be translated). 
     * @param {Promise} hidePromise this will close the dialog once the promise its completed.
     * @param {Promise} hidePromise2 this will close the dialog once the promise its completed.
     * @param {boolean} shouldModalStayAsIs Optional, used to reset the window scroll to the top if true. Only relevant if the dialog is closed by the promise.
     * @param {number} initDelay Optional, delay on opening the progress modal, 1 second delay by default.
     */
    const showProgressDialogTwoPromises = (title, hidePromise, hidePromise2, shouldModalStayAsIs, initDelay = 1000)=> {
        updateProgressModalState({
            type: 'ACTIVATE',
            title,
            initDelay
        });
        if(hidePromise && hidePromise2){
            Promise.all([hidePromise, hidePromise2]).then((response) => {
                if (!shouldModalStayAsIs) {
                    window.scrollTo(0, 0);
                }
                updateProgressModalState({
                    type: 'DEACTIVATE'
                });

                return response;
            }).catch((error) => {
                if (!shouldModalStayAsIs) {
                    window.scrollTo(0, 0);
                }
                updateProgressModalState({
                    type: 'DEACTIVATE'
                });
                return error;
            })
        }
    };

    /**
     * If the progress modal was showed without using a hide promise, use this function to hide it. @see {@link showProgressDialog}
     * @param {boolean} shouldModalStayAsIs Optional, used to reset the window scroll to the top if true.
     */
    const hideProgressDialog = (shouldModalStayAsIs) => {
        updateProgressModalState({
            type: 'DEACTIVATE'
        });
        if (!shouldModalStayAsIs) {
            window.scrollTo(0, 0);
        }
    };

    return {
        showErrorModal: showErrorModal,
        showInfo: showInfo,
        showProgressDialog,
        hideProgressDialog,
        showProgressDialogTwoPromises
    };
}


export default MLModalService;
